/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.circle-plus\":\"Sirkel med plusstegn\"}");